"use strict";

function qmSomosScroll() {
    const menus = document.querySelectorAll(
        ".menu-quem-somos .c-main-menu__item"
    );
    const sectionContainer = document.querySelectorAll(".js-scroll");

    const windowMetade = window.innerHeight * 0.3;

    menus.forEach((item) => {
        item.addEventListener("click", () => {
            menus.forEach((item) => item.classList.remove("active"));
            item.classList.add("active");
        });
    });

    function hoverScroll() {
        sectionContainer.forEach((content, index) => {
            const contentTop = content.getBoundingClientRect().top;
            const isContentVisible = contentTop - windowMetade < 0;
            if (isContentVisible) {
                menus.forEach((item) => item.classList.remove("active"));
                menus[index].classList.add("active");
            } else {
                menus[index].classList.remove("active");
            }
        });
    }

    window.addEventListener("scroll", hoverScroll);

    function scrollToSection(event) {
        event.preventDefault();
        const href = event.currentTarget.getAttribute("href");
        const section = document.querySelector(href);
        const topo = section.offsetTop;
        window.scrollTo({
            top: topo,
            behavior: "smooth",
        });
    }

    menus.forEach((link) => {
        link.querySelector(".c-main-menu__link").addEventListener(
            "click",
            scrollToSection
        );
    });
}

export default function () {
    const sliderEl = document.querySelector(".js-scroll");

    if (sliderEl) {
        qmSomosScroll();
    }
}
